"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringifyExtensions = exports.getIsValidFiles = exports.convertBytes2Mb = void 0;
var _ramda = require("ramda");
var getFileExtension = (0, _ramda.pipe)((0, _ramda.split)('.'), _ramda.last, _ramda.toLower);
var getIsValidFiles = exports.getIsValidFiles = function getIsValidFiles(files, extensions, maxFileSizeInBytes) {
  return (0, _ramda.all)(function (_ref) {
    var name = _ref.name,
      size = _ref.size;
    var fileExtension = getFileExtension(name);
    return (0, _ramda.and)((0, _ramda.includes)(fileExtension, extensions), size <= maxFileSizeInBytes);
  }, files);
};
var stringifyExtensions = exports.stringifyExtensions = function stringifyExtensions(extensions) {
  return (0, _ramda.join)(', ', (0, _ramda.map)((0, _ramda.concat)('.'), extensions));
};
var convertBytes2Mb = exports.convertBytes2Mb = function convertBytes2Mb(size) {
  return size / 1024 / 1024;
};